<template>
  <q-page padding>
    <PageHeader
      title="Logs de Tentativas Malsucedidas"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />

    <section class="column">
      <div style="height: 100px" class="row justify-around">
        <span class="col-3">
          <q-card style="height: 100px" class="my-card bg-positive text-white">
            <q-card-section>
              <div v-if="info.requisicoes_finalizadas" class="text-h6">
                {{ info.requisicoes_finalizadas }}
              </div>
              <div class="text-h6" v-else>Total Entregas</div>
            </q-card-section>
            <div class="bg-sub absolute-bottom text-subtitle2 text-center">
              Total Entregas
            </div>
          </q-card>
        </span>
        <span class="q-ml-md col-3">
          <q-card style="height: 100px" class="my-card bg-negative text-white">
            <q-card-section>
              <div v-if="info.tentativas_com_erro" class="text-h6">
                {{ info.tentativas_com_erro }}
              </div>
              <div class="text-h6" v-else>Total Erros</div>
            </q-card-section>
            <div class="bg-sub absolute-bottom text-subtitle2 text-center">
              Total Erros
            </div>
          </q-card>
        </span>
        <span class="q-ml-md col-3">
          <q-card style="height: 100px" class="my-card bg-primary text-white">
            <q-card-section>
              <div v-if="info.produtos_diferentes" class="text-h6">
                {{ info.produtos_diferentes }}
              </div>
              <div class="text-h6" v-else>Produtos diferentes com problema</div>
            </q-card-section>
            <div class="bg-sub absolute-bottom text-subtitle2 text-center">
              Produtos diferentes com problema
            </div>
          </q-card>
        </span>
        <span class="q-ml-md col-2">
          <q-card style="height: 100px" class="my-card bg-primary text-white">
            <q-card-section>
              <div v-if="info.top_molas" class="text-h6">
                {{ info.top_molas[1] }}/ {{ info.top_molas[2] }}/
                {{ info.top_molas[3] }}
              </div>
              <div class="text-h6" v-else>TOP 3 Molas com problema</div>
            </q-card-section>
            <div class="bg-sub absolute-bottom text-subtitle2 text-center">
              TOP 3 Molas com problema
            </div>
          </q-card>
        </span>
      </div>

      <div class="row q-mt-md justify-around">
        <span class="q-mr-sm" style="width: 48%">
          <q-card
            style="height: 100px"
            class="col-5 my-card bg-secondary text-white"
          >
            <q-card-section>
              <div v-if="info.produto_mais_ocorrencia" class="text-h6">
                {{ info.produto_mais_ocorrencia }}
              </div>
              <div class="text-h6" v-else>Produto com mais problemas</div>
            </q-card-section>
            <div class="bg-sub absolute-bottom text-subtitle2 text-center">
              Produto com mais problemas
            </div>
          </q-card>
        </span>
        <span style="width: 48%">
          <q-card style="height: 100px" class="my-card bg-secondary text-white">
            <q-card-section>
              <div v-if="info.quantidade_log_produto" class="text-h6">
                {{ info.quantidade_log_produto }}
              </div>
              <div class="text-h6" v-else>Erros deste produto</div>
            </q-card-section>
            <div class="bg-sub absolute-bottom text-subtitle2 text-center">
              Erros deste produto
            </div>
          </q-card>
        </span>
      </div>
    </section>

    <section class="column q-mb-md">
      <div class="row q-mt-xl q-mb-md">
        <div class="col-2">
          <lista-unidades-select v-model="unidade"></lista-unidades-select>
        </div>
        <div class="col-md-5 q-ml-sm">
          <q-input
            mask="##/##/####"
            dense
            label="Data Inicial"
            outlined
            v-model="dados.data_inicial"
          >
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    :locale="myLocale"
                    mask="DD/MM/YYYY"
                    v-model="dados.data_inicial"
                  >
                    <div class="row items-center justify-end">
                      <q-btn
                        v-close-popup
                        label="Fechar"
                        color="primary"
                        flat
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
        <div class="col-md-4 q-ml-sm">
          <q-input
            mask="##/##/####"
            dense
            outlined
            label="Data Final"
            v-model="dados.data_final"
          >
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    :locale="myLocale"
                    mask="DD/MM/YYYY"
                    v-model="dados.data_final"
                  >
                    <div class="row items-center justify-end">
                      <q-btn
                        v-close-popup
                        label="Fechar"
                        color="primary"
                        flat
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <q-input dense outlined label="Usuário" v-model="dados.search" />
        </div>
        <div class="col-md-4 q-ml-sm">
          <q-input dense outlined label="Busca por mola" v-model="dados.mola" />
        </div>
        <div class="col-md-3 q-ml-sm">
          <q-input
            dense
            outlined
            label="Busca por Código ou nome do Produto"
            v-model="dados.produto"
          />
        </div>
      </div>

      <section class="q-mt-md row">
        <div class="col-md-3">
          <q-btn
            color="secondary"
            icon="filter_alt"
            no-caps
            label="Aplicar filtros"
            @click="getTentativas"
          />
        </div>
      </section>
    </section>

    <div class="q-mt-sm">
      <q-table
        flat
        table-header-class="bg-accent text-width-bold"
        :title="'LOGS -' + ' ' + rows.length + ' ' + 'Registros'"
        :filter="filter"
        dense
        class="tabela-tamanho-fixo"
        :rows="rows"
        :columns="columns"
        :loading="disable"
        v-model:pagination="pagination"
        :rows-per-page-options="[0]"
        @request="handleRequest"
      >
        <template v-slot:top-right>
          <div class="row">
            <div class="q-mr-sm">
              <q-btn
                color="secondary"
                class="q-ml-sm"
                label="exportar"
                @click="exportar"
              />
            </div>
            <div>
              <q-input
                outlined
                rounded
                dense
                debounce="300"
                v-model="filter"
                placeholder="Buscar"
              >
                <template v-slot:append>
                  <q-icon name="search" />
                </template>
              </q-input>
            </div>
          </div>
        </template>
        <template #body-cell-maquina="props">
          <q-td>
            <div class="row">
              <span>{{ props.row.location }}</span>
              <span class="q-ml-sm">({{ props.row.machine_user_name }})</span>
            </div>
          </q-td>
        </template>
        <template #body-cell-usuario="props">
          <q-td>
            <div class="row">
              <span>{{ props.row.user_name }}</span>
              <span class="q-ml-sm">({{ props.row.user_email }})</span>
            </div>
          </q-td>
        </template>
        <template #body-cell-data_falha="props">
          <q-td>
            {{
              props.row.data_falha.split(" ")[0].split("-").reverse().join("/")
            }}
            {{ props.row.data_falha.split(" ")[1] }}
          </q-td>
        </template>
      </q-table>
    </div>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "maquina",
    label: "Máquina",
    field: "maquina",
    align: "left",
  },
  {
    name: "usuario",
    label: "Usuário",
    field: "usuario",
    align: "left",
  },
  {
    name: "product_name",
    label: "Produto",
    field: "product_name",
    align: "left",
  },
  {
    name: "amount",
    label: "Quantidade",
    field: "amount",
    align: "left",
  },
  {
    name: "number",
    label: "Mola",
    field: "number",
    align: "left",
  },
  {
    name: "motivo",
    label: "Motivo",
    field: "motivo",
    align: "left",
  },
  {
    name: "data_falha",
    label: "Data Tentativa",
    field: "data_falha",
    align: "left",
  },
];

import { ref, onMounted, watch } from "vue";
import { useQuasar } from "quasar";
import { useStore } from "vuex";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";

import PageHeader from "../../../../components/PageHeader.vue";

export default {
  components: { ListaUnidadesSelect, PageHeader },
  props: ["atualizar"],
  setup(props) {
    const store = useStore();
    const $q = useQuasar();
    const rows = ref([]);
    const disable = ref(true);
    const unidade = ref();

    const info = ref({});
    let filter = ref("");
    const dados = ref({
      data_inicial: "",
      data_final: "",
      search: "",
      mola: "",
      produto: "",
    });

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 15,
      rowsNumber: 15,
    });

    const getTentativas = async () => {
      try {
        let response = await store.dispatch("maquina/listarTentativas", {
          vendor_id: store.state.org.unidadeData.id,
          data_inicial: dados.value.data_inicial,
          data_final: dados.value.data_final,
          search: dados.value.search,
          mola: dados.value.mola,
          produto: dados.value.produto,
          nome_maquina: filter.value,
        });

        info.value = response.data.hightlights;

        rows.value = response.data.results;

        disable.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    onMounted(getTentativas);

    const exportar = async () => {
      try {
        await store.dispatch("maquina/exportar", {
          vendor_id: store.state.org.unidadeData.id,
        });

        $q.notify({
          message: "Dados exportados com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        $q.notify({
          message: "Erro a o exportar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const handleRequest = async () => {
      getTentativas(pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => props.atualizar,
      () => {
        setTimeout(() => {
          getTentativas();
        }, 1000);
      }
    );

    watch(
      () => filter.value,
      () => {
        handleRequest();
      }
    );

    watch(
      () => dados.value,
      () => {
        getTentativas();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        getTentativas();
      }
    );

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);

    return {
      columns,
      rows,
      getTentativas,
      disable,
      filter,
      handleRequest,
      dados,
      unidade,
      pagination,
      myLocale: {
        /* starting with Sunday */
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      info,
      exportar,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}

.circle {
  width: 12px;
  height: 12px;

  border-radius: 50%;
}

.align {
  align-items: center;
}

.bg-sub {
  background: rgba(0, 0, 0, 0.47);
}
</style>
